import React from 'react';
import { Label, Pane, PropertyGrid, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelEditorFactory, ModelTypeSelector } from '@leverege/ui-plugin';
import { UnitSelector, Attributes } from '@leverege/ui-attributes';
import { Plugins } from '@leverege/plugin';
import { ns } from '@leverege/i18n';
import UnitAttributeCoordinateModel from "../../models/coordinate/UnitAttributeCoordinateModel.js";
const {
  t
} = ns('ui-attributes-graphs.editors.UnitAttributeCoordinateEditor');
export default function UnitAttributeCoordinateEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(UnitAttributeCoordinateModel, props);
  const scale = UnitAttributeCoordinateModel.getScale(value);
  const formatter = UnitAttributeCoordinateModel.getFormatter(value);
  const formatterEditor = formatter && ModelEditorFactory.create(formatter, {
    eventData: 'setFormatter',
    onChange: onModelChange
  });
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "attributeCoordinateEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('label')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: UnitAttributeCoordinateModel.getLabel(value),
    eventData: "setLabel",
    onChange: onModelChange
  })), formatterEditor && /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    fill: true,
    label: t('tickFormat')
  }, formatterEditor), /*#__PURE__*/React.createElement(PropertyGrid.Divider, null), /*#__PURE__*/React.createElement(PropertyGrid.Header, {
    title: t('scale')
  }), ModelTypeSelector.createSelectorAndEditor({
    values: Plugins.get('ScaleModel'),
    value: scale,
    eventData: 'setScale',
    onChange: onModelChange,
    allowNone: false,
    isPropertyGrid: true,
    label: t('type')
  }));
}